import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const Battery80FilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M9.24014 7.10078H5.64014V5.30078H9.24014V7.10078ZM18.3603 7.10078H14.7603V5.30078H18.3603V7.10078ZM6.0001 10.0407H18.0001C18.3315 10.0407 18.6001 10.3094 18.6001 10.6407V15.4407C18.6001 15.7721 18.3315 16.0407 18.0001 16.0407H6.0001C5.66873 16.0407 5.4001 15.7721 5.4001 15.4407V10.6407C5.4001 10.3094 5.66873 10.0407 6.0001 10.0407ZM3.6001 10.6407C3.6001 9.31524 4.67461 8.24072 6.0001 8.24072H18.0001C19.3256 8.24072 20.4001 9.31524 20.4001 10.6407V15.4407C20.4001 16.7662 19.3256 17.8407 18.0001 17.8407H6.0001C4.67462 17.8407 3.6001 16.7662 3.6001 15.4407V10.6407Z"
      />
      <path d="M6.6001 11.6002C6.6001 11.4014 6.76128 11.2402 6.9601 11.2402H15.2401V14.8402H6.9601C6.76127 14.8402 6.6001 14.6791 6.6001 14.4802V11.6002Z" />
    </SvgIcon>
  );
});
